var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceTv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.555,
    height: 16.444,
    viewBox: "0 0 20.555 16.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.014,0H1.542A1.542,1.542,0,0,0,0,1.542V11.819a1.542,1.542,0,0,0,1.542,1.542H9.414v1.028H4.275a1.028,1.028,0,1,0,0,2.056H16.608a1.028,1.028,0,0,0,0-2.056H11.469V13.361h7.544a1.542,1.542,0,0,0,1.542-1.542V1.542A1.542,1.542,0,0,0,19.014,0ZM18.5,11.305H2.056V2.056H18.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTv);
export default __webpack_public_path__ + "static/media/deviceTv.a9fa7d89026a04f26ef56b403ecd9251.svg";
export { ForwardRef as ReactComponent };